import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { PracticeAuthProvider } from "../../context/PracticeAuthContext";
import { PracticeChatsProvider } from "../../context/PracticeChatsContext";
import IncomingCallBanner from "./components/IncomingCallBanner";
import PageLoader from "../../core/common/pageLoader/PageLoader";

// Each page under /speaking-partner/* renders its own PracticePageHeader
// (mirrors the shared site-wide PageHeader, identity chip + logout included),
// so this layout only needs to mount the auth provider and the page background.
const SpeakingPartnerLayout: React.FC = () => {
  return (
    <PracticeAuthProvider>
      <PracticeChatsProvider>
        <div className="min-h-screen bg-gray-100">
          <IncomingCallBanner />
          <Suspense fallback={<PageLoader />}>
            <Outlet />
          </Suspense>
        </div>
      </PracticeChatsProvider>
    </PracticeAuthProvider>
  );
};

export default SpeakingPartnerLayout;
